import { lazyNamed } from 'src/utils/lazyNamed';

export const BroadcastProducts = {
  AdMedia: lazyNamed(() => import('./pages/AdMedia'), 'AdMedia'),
  AdMediaHistory: lazyNamed(() => import('./pages/AdMedia/containers/AdMediaHistory'), 'AdMediaHistory'),

  AdPlacements: lazyNamed(() => import('./pages/AdPlacements'), 'AdPlacements'),
  AdPlacementForm: lazyNamed(() => import('./pages/AdPlacements/containers/AdPlacementForm'), 'AdPlacementForm'),
  AdPlacementHistory: lazyNamed(() => import('./pages/AdPlacements/containers/AdPlacementHistory'), 'AdPlacementHistory'),

  AdTypes: lazyNamed(() => import('./pages/AdTypes'), 'AdTypes'),
  AdTypeHistory: lazyNamed(() => import('./pages/AdTypes/containers/AdTypeHistory'), 'AdTypeHistory'),

  Products: lazyNamed(() => import('./pages/Products'), 'Products'),
  ProductForm: lazyNamed(() => import('./pages/Products/containers/ProductForm'), 'ProductForm'),
  ProductHistory: lazyNamed(() => import('./pages/Products/containers/ProductHistory'), 'ProductHistory'),

  AdPrices: lazyNamed(() => import('./pages/AdPrices'), 'AdPrices'),
  CreateAdPriceForm: lazyNamed(() => import('./pages/AdPrices/containers/CreateAdPriceForm'), 'CreateAdPriceForm'),
  EditAdPriceForm: lazyNamed(() => import('./pages/AdPrices/containers/EditAdPriceForm'), 'EditAdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./pages/AdPrices/containers/AdPriceHistory'), 'AdPriceHistory'),
};
